@if (brandImg()) {
    <a [routerLink]="routerLink()">
        @if (brandFull()) {
            <img [sfHtmlAttributes]="brandFull()" [ngClass]="'sidebar-brand-full'" />
        }
        @if (brandNarrow()) {
            <img [sfHtmlAttributes]="brandNarrow()" [ngClass]="'sidebar-brand-narrow'" />
        }
    </a>
} @else {
    <ng-content />
}
